﻿import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute,Params } from '@angular/router';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { GenService } from '../../shared/gen-ser.service';
import { DataService } from '../../shared/dataservice.service';
import { CustomerInspectionPlan, CIPToken, CIPDayToken, DailyToken, DailyTokenItem, Plan, GenResponse, DailyProdHighlights, DPHToken } from '../../shared/misc-classes';
import { NotificationsService } from 'angular2-notifications';
import { ErrorPopupComponent } from '../../common/error-popup/error-popup.component';

@Component({
  selector: 'app-cust-insp-plan',
  templateUrl: './cust-insp-plan.component.html',
  styleUrls: ['./cust-insp-plan.component.css']
})
export class CustInspPlanComponent implements OnInit {

  editToken:string = '';
  editHeader:string = '';
  editText:string = '';
  editType:string = '';
  editParam1:any;
  editParam2:any;
  planObj:Plan;
  btnName:string = '';
  editRow:CIPToken;
  currMonthDtObj:Date = new Date();
  datatables:CustomerInspectionPlan;
  dCIPDayTokenObj:CIPDayToken;

  isLoading:boolean = false;
  isLoaded:boolean = false;
  isFailed:boolean = false;
  failMessage:string = '';

  selView: number = 1;
  areChangesMade:boolean = false;

  mId:string = "72b9d798-a413-408c-940e-9cd2bfbaa407";
  hasmodaccess:boolean = false;
  daywiseItemList: Array<DailyToken>;
  
  // Track all pending operations (updates/deletions) to sync back to Production Plan
  pendingOperations: Array<{type: 'update' | 'delete', productName: string, customerName: string, sourceMonth?: Date, newDate?: Date, quantity?: number}> = [];
  // Track valid product/customer pairs from Production Plan for orphan detection
  private validProdPlanKeys: Set<string> = new Set();
  // Track source Production Plan month for each product/customer pair (for efficient sync)
  private sourceMonthMap: Map<string, Date> = new Map();

  @ViewChild('childModal') public childModal:ModalDirective;  
  @ViewChild(ErrorPopupComponent) errorPopup:ErrorPopupComponent;

  constructor(private _dataService:DataService,
              private _activatedRoute:ActivatedRoute, private _notify:NotificationsService) { }

  ngOnInit() {
    this._dataService.currPageName = "Customer Inspection Plan Highlights";

    this._activatedRoute.queryParams.subscribe((params:Params) => {
      if(params['month']){
        this.currMonthDtObj = new Date(parseInt(params['month']));
      }
      this.loadMonthData();
      this.loadPlan();
    });
  }

  checkModAccess():boolean{
    if(this._dataService.mAccess(this.mId) == true){
      this.hasmodaccess = true; 
    }
    else{
      this.hasmodaccess = false; 
    }
    return this.hasmodaccess;
  }
  hasEditAccess(_pid:string){
    return this._dataService.hasEditAccess(this.mId,_pid);
  }
  hasReadAccess(_pid:string){
    return this._dataService.hasReadAccess(this.mId,_pid);
  }
  loadPlan(){
    this._dataService.loadPlan(this.currMonthDtObj).subscribe((_dailyProdHigh: Plan) => {
      if (_dailyProdHigh != null) {
        this.planObj = _dailyProdHigh;
      }
    });
  }
  loadMonthData(){
    this.isLoading = true;
    this.isLoaded = false;
    this.isFailed = false;
    this.failMessage = '';
    this.areChangesMade = false;
    this.pendingOperations = [];
    this.sourceMonthMap.clear();
    this._dataService.loadCustmrInspPlan(this.currMonthDtObj).subscribe((_cstInspPlan:CustomerInspectionPlan) => {
        if(_cstInspPlan!=null){
          this.datatables = _cstInspPlan;
          // Merge FAT-date rows from Production Plan across a wider month span (past + future)
          this.loadAndMergeProdHighlightsSpan(12, 12, () => {
            this.loadDateData();
            this.rebuildMonthItems();
            this.isLoaded = true;
            this.isLoading = false;
            this.isFailed = false;
          });
        }
        else{
          this.daywiseItemList = null;
          this.isLoaded = false;
          this.isLoading = false;
          this.isFailed = true;
          this.failMessage = "Failed to get data from database, try again";
        }
    });
  }

  private getDisplayTokenName(_prodId:string,_quantity:number){
    return this._dataService.getCustomerName(_prodId) + ' ('+_quantity+')';
  }
  private getIdObj(_selDate:Date,_itemIndex:number){
    return {"selDate":_selDate,"rowIndex":_itemIndex}
  }
  
  ItemSelected(_evntObj){
    this.selView = 1;
    this.currMonthDtObj.setDate(_evntObj.selDate.getDate());
    this.loadDateData();
  }

  public showChildModal(_editToken:string,_param1:any,_param2:any):void {
    switch(_editToken){
      case "rowedit":
      this.btnName = "Done";
        this.editRow = _param1.cloneSelf();
        this.editType = _editToken;
        this.editHeader = "Edit Customer Inspection Plan (" + this.formatHeaderDate(this.dCIPDayTokenObj.selDate) +")";
      break;
      case "rownew":
      this.btnName = "Done";
        this.editRow = new CIPToken(null,null,null,0,0,null,this.currMonthDtObj.getTime(),null,(new Date()).getTime());
        this.editType = _editToken;
        this.editHeader = "Add Customer Inspection Plan (" + this.formatHeaderDate(this.dCIPDayTokenObj.selDate) +")";
      break;
      case "selplan":
      this.btnName = "Save";
        this.editText = this.planObj.description;
        this.editType = 'text';
        this.editHeader = "Edit Plan";
      break;
    }
    this.editParam1 = _param1;
    this.editParam2 = _param2;
    this.editToken = _editToken;
    this.childModal.show();
  }

  public addNewProdRow(_newRowToken: string, _selDate: Date) {
    switch (_newRowToken) {
      case "rownew":
        this.showChildModal(_newRowToken,null,null);
        break;
    }
  }
  public removeRecord( _tokenIndex:number) {
    // Track deletion to sync to Production Plan
    const token = this.dCIPDayTokenObj.dateTokens[_tokenIndex];
    if (token) {
      const key = `${token.productName}||${token.customerName}`;
      const sourceMonth = this.sourceMonthMap.get(key);
      this.pendingOperations.push({ type: 'delete', productName: token.productName, customerName: token.customerName, sourceMonth });
    }
    this.dCIPDayTokenObj.removeToken(_tokenIndex); 
    this.areChangesMade = true;   
  }

  dataEdited(){
    switch(this.editToken){
      case "rowedit":
        const oldDate = this.dCIPDayTokenObj.selDate;
        const newDate = new Date(this.editRow.dateNum);
        const dateChanged = this.normalizeDay(oldDate) !== this.normalizeDay(newDate);
        const quantityChanged = this.editParam1.quantity !== this.editRow.quantity;
       
        // Track changes to sync back to Production Plan (both date and quantity)
        if(dateChanged || quantityChanged) {
          const key = `${this.editParam1.productName}||${this.editParam1.customerName}`;
          const sourceMonth = this.sourceMonthMap.get(key);
          this.pendingOperations.push({
            type: 'update',
            productName: this.editParam1.productName,
            customerName: this.editParam1.customerName,
            sourceMonth,
            newDate,
            quantity: this.editRow.quantity
          });
        }
        
        if(dateChanged) {
          // Remove from current day and add to new date
          const idx = this.dCIPDayTokenObj.dateTokens.indexOf(this.editParam1);
          if(idx >= 0) this.dCIPDayTokenObj.removeToken(idx);
          
          this.datatables.addDateToken(newDate, this.createTokenFromEditRow());
          this.rebuildMonthItems();
          this.loadDateData();
        } else {
          this.copyEditRowToParam();
        }
        break;

      case "rownew":
        this.datatables.addDateToken(new Date(this.currMonthDtObj), this.createTokenFromEditRow());
        break;

      case "selplan":
        this.datatables.plan = this.editText;
        this.planObj.description = this.editText;
        this.planObj.monthDateNum = this.currMonthDtObj.getTime();
        this.savePlan();      
        break;
    }
    this.areChangesMade = true;
    this.hideChildModal();
  }

  private createTokenFromEditRow(): CIPToken {
    return new CIPToken(
      this.editRow.productName, this.editRow.customerName, this.editRow.inspectionDoneBy,
      this.editRow.quantity, this.editRow.witnessQuantity, this.editRow.cb,
      this.editRow.dateNum, this.editRow.respPrsn, this.editRow.creationDate
    );
  }

  private copyEditRowToParam(): void {
    this.editParam1.productName = this.editRow.productName;
    this.editParam1.customerName = this.editRow.customerName;
    this.editParam1.inspectionDoneBy = this.editRow.inspectionDoneBy;
    this.editParam1.quantity = this.editRow.quantity;
    this.editParam1.witnessQuantity = this.editRow.witnessQuantity;
    this.editParam1.cb = this.editRow.cb;
    this.editParam1.respPrsn = this.editRow.respPrsn;
  }

  formatHeaderDate(_date:Date):string{
    if (_date) {
      return GenService.getDateFormatStr(_date, "DD-MMM");
    }
    return '-';
  }

  formatDate(_date:Date):string{
    if(_date)  return GenService.getDateFormatStr(_date, "DD-mmm-YYYY");
    return '-';
  }

  public hideChildModal():void {
    this.childModal.hide();
  }

  public cancelSaveData():void {
     switch(this.editToken){
      case "rowedit":
      case "rownew":
        this.loadMonthData();
        this.loadPlan();
      }
      this.childModal.hide();
  }
  saveData(_sendMail: boolean): void {
    if (this.validateData() == true) {
      this._dataService.saveCustmrInspPlan(this.datatables, _sendMail).subscribe((resp: GenResponse) => {
        if (resp.status == DataService.statusFail) {
          if (resp.errorCode == DataService.staleDataCode) {
            this.errorPopup.showErrorPopup("Stale Data", DataService.staleDateErrorMsg)
          } else {
            this._notify.error('Failure', resp.details, this._dataService.failureOptions);
          }
        }
        else {
          // Sync changes to Production Plan
          if (this.pendingOperations.length > 0) {
            this.syncChangesToProductionPlan(() => {
              this.pendingOperations = [];
              this._notify.success('Success', resp.details, this._dataService.successOptions);
              this.loadMonthData();
              this.loadPlan();
            });
          } else {
            this._notify.success('Success', resp.details, this._dataService.successOptions);
            this.loadMonthData();
            this.loadPlan();
          }
        }

      });
    }
  }
  savePlan() {
    this._dataService.savePlan(this.planObj).subscribe((resp: GenResponse) => {
      if (resp.status == DataService.statusFail) {
        if (resp.errorCode == DataService.staleDataCode) {
          this.errorPopup.showErrorPopup("Stale Data", DataService.staleDateErrorMsg)
        } else {
          this._notify.error('Failure', resp.details, this._dataService.failureOptions);
        }
      }
      else {
        this._notify.success('Success', resp.details, this._dataService.successOptions);
        this.loadMonthData();
        this.loadPlan();
      }

    });
  }
  
  discardData():void{
    this.loadMonthData();
    this.loadPlan();
  }
  validateData():boolean{
    return true;
  }

  prevMonthSel():void{
    this.currMonthDtObj.setMonth(this.currMonthDtObj.getMonth() - 1);
    this.currMonthDtObj.setDate(1);
    this.loadMonthData();
    this.loadPlan();
  }
  nextMonthSel(){
    this.currMonthDtObj.setMonth(this.currMonthDtObj.getMonth() + 1);
    this.currMonthDtObj.setDate(1);
    this.loadMonthData();
    this.loadPlan();
  }

  prevDateSel():void{
    if(this.currMonthDtObj.getDate() > 1){
      this.currMonthDtObj.setDate(this.currMonthDtObj.getDate()-1);
      this.loadDateData();
    }
  }
  nextDateSel():void{
    var _tmpLastDayOfMonth:Date = new Date(this.currMonthDtObj.getFullYear(),this.currMonthDtObj.getMonth()+1,0);
    if(this.currMonthDtObj.getDate() < _tmpLastDayOfMonth.getDate()){
      this.currMonthDtObj.setDate(this.currMonthDtObj.getDate()+1);
      this.loadDateData();
    }
  }

  loadDateData():void{
    let _tmpDPHDayToken:CIPDayToken = this.datatables.getDateToken(this.currMonthDtObj);
    if(_tmpDPHDayToken == null){
      this.datatables.addDateToken(this.currMonthDtObj);  
      _tmpDPHDayToken = this.datatables.getDateToken(this.currMonthDtObj);
    }
    this.dCIPDayTokenObj = _tmpDPHDayToken;
  }

  // Combine FAT-date items from Production Plan into Inspection tokens
  private mergeFatIntoInspection(dph: DailyProdHighlights, sourceMonth: Date): void {
    const month = this.currMonthDtObj.getMonth();
    const year = this.currMonthDtObj.getFullYear();

    for (const day of dph.dayTokens) {
      if (!day || !day.dateTokens) continue;
      
      for (const row of day.dateTokens) {
        const fatTimestamp = this.parseFatDateWithDefaultYear(row.fatDate, year);
        if (!fatTimestamp) continue;
        
        const fatDate = new Date(fatTimestamp);
        if (fatDate.getMonth() !== month || fatDate.getFullYear() !== year) continue;

        const productName = this._dataService.getProductName(row.productId) || row.productId;
        const customerName = this._dataService.getCustomerName(row.customerId) || row.customerId;
        const key = `${productName}||${customerName}`;
        
        this.validProdPlanKeys.add(key);
        this.sourceMonthMap.set(key, sourceMonth);
        
        const existing = this.findExistingCIPToken(productName, customerName);
        
        if (existing) {
          this.updateExistingToken(existing, row.quantity || 0, fatDate, fatTimestamp);
        } else {
          this.addNewCIPToken(productName, customerName, row.quantity || 0, fatTimestamp, row.creationDate, fatDate);
        }
      }
    }
  }

  // Find existing CIP token by product/customer name
  private findExistingCIPToken(productName: string, customerName: string): { token: CIPToken, dayToken: CIPDayToken, index: number } | null {
    for (const dayToken of this.datatables.dayTokens) {
      const idx = dayToken.dateTokens.findIndex(t => t.productName === productName && t.customerName === customerName);
      if (idx >= 0) {
        return { token: dayToken.dateTokens[idx], dayToken, index: idx };
      }
    }
    return null;
  }

  // Update existing CIP token with new quantity and move to correct date if needed
  private updateExistingToken(existing: { token: CIPToken, dayToken: CIPDayToken, index: number }, quantity: number, fatDate: Date, fatTimestamp: number): void {
    existing.token.quantity = quantity;
    
    const existingDateNormalized = this.normalizeDay(existing.dayToken.selDate);
    const fatDateNormalized = this.normalizeDay(fatDate);
    
    if (fatDateNormalized !== existingDateNormalized) {
      existing.dayToken.removeToken(existing.index);
      existing.token.dateNum = fatTimestamp;
      
      const targetDayToken = this.datatables.getDateToken(fatDate);
      targetDayToken ? targetDayToken.addToken(existing.token) : this.datatables.addDateToken(fatDate, existing.token);
    }
  }

  // Add new CIP token from Production Plan data
  private addNewCIPToken(productName: string, customerName: string, quantity: number, fatTimestamp: number, creationDate: number, fatDate: Date): void {
    const cip = new CIPToken(productName, customerName, null, quantity, 0, null, fatTimestamp, null, creationDate);
    const dayToken = this.datatables.getDateToken(fatDate);
    dayToken ? dayToken.addToken(cip) : this.datatables.addDateToken(fatDate, cip);
  }

  private rebuildMonthItems(): void {
    let _tmpDailyTokenList: Array<DailyToken> = [];
    for (var i = 0; i < this.datatables.dayTokens.length; i++) {
      let _tmpDate:Date = this.datatables.dayTokens[i].selDate;
      let _tmpDailyTokens:Array<DailyTokenItem> = [];
      let _indexer:number = 0;
      this.datatables.dayTokens[i].dateTokens.forEach((_tmpObj:CIPToken) => {
        _tmpDailyTokens.push(new DailyTokenItem( this.getDisplayTokenName(_tmpObj.customerName,_tmpObj.quantity), this.getIdObj(_tmpDate,_indexer),''));
        _indexer++;
      });
      _tmpDailyTokenList.push(new DailyToken(_tmpDate, _tmpDailyTokens));
    }
    this.daywiseItemList = _tmpDailyTokenList;
  }

  private normalizeDay(d: Date): number {
    if (!d) return 0;
    const x = new Date(d.getTime());
    x.setHours(0,0,0,0);
    return x.getTime();
  }

  // Robust parsing for various FAT date formats
  private parseFatDate(val: any): number {
    if (!val) return 0;
    if (val instanceof Date) return val.getTime();
    if (typeof val === 'number') return val;
    if (typeof val === 'string') {
      if (/^\d{4}-\d{2}-\d{2}/.test(val)) {
        const t = Date.parse(val);
        if (!isNaN(t)) return t;
      }
      // dd-MM-yyyy or dd/MM/yyyy
      if (/^\d{2}[-\/]\d{2}[-\/]\d{4}$/.test(val)) {
        const parts = val.split(/[-\/]/).map(Number);
        const [d, m, y] = parts;
        const dt = new Date(y, m - 1, d).getTime();
        if (!isNaN(dt)) return dt;
      }
      const t2 = Date.parse(val);
      if (!isNaN(t2)) return t2;
    }
    return 0;
  }

  // Parse dd/MM or dd-MM by assuming the selected year
  private parseFatDateWithDefaultYear(val: any, defaultYear: number): number {
    const t = this.parseFatDate(val);
    if (t) return t;
    if (typeof val === 'string') {
      if (/^\d{2}[-\/]\d{2}$/.test(val)) {
        const parts = val.split(/[-\/]/).map(Number);
        const [d, m] = parts;
        const dt = new Date(defaultYear, m - 1, d).getTime();
        if (!isNaN(dt)) return dt;
      }
    }
    return 0;
  }

  // Load Production Plan for a month span around the currently viewed month and merge FAT rows
  private loadAndMergeProdHighlightsSpan(monthsBack: number, monthsForward: number, onDone: () => void): void {
    const base = new Date(this.currMonthDtObj.getTime());
    base.setDate(1);
    const dates: Date[] = [];
    for (let i = -monthsBack; i <= monthsForward; i++) {
      const d = new Date(base.getTime());
      d.setMonth(base.getMonth() + i);
      d.setDate(1);
      dates.push(d);
    }
    this.validProdPlanKeys.clear();
    
    const process = (idx: number) => {
      if (idx >= dates.length) { 
        this.removeOrphanedCIPEntries();
        onDone(); 
        return; 
      }
      this._dataService.loadDailyProdHighlights(dates[idx]).subscribe((dph: DailyProdHighlights) => {
        try { if (dph && dph.dayTokens) this.mergeFatIntoInspection(dph, dates[idx]); } catch(e){}
        process(idx + 1);
      }, _ => process(idx + 1));
    };
    process(0);
  }

  // Remove CIP entries that no longer exist in Production Plan
  private removeOrphanedCIPEntries(): void {
    const month = this.currMonthDtObj.getMonth();
    const year = this.currMonthDtObj.getFullYear();
    
    for (const dayToken of this.datatables.dayTokens) {
      // Check if this day is in the current month
      if (dayToken.selDate.getMonth() !== month || dayToken.selDate.getFullYear() !== year) continue;
      
      // Iterate in reverse to safely remove items
      for (let i = dayToken.dateTokens.length - 1; i >= 0; i--) {
        const t = dayToken.dateTokens[i];
        const key = `${t.productName}||${t.customerName}`;
        
        // no longer exists in Production Plan, remove it
        if (!this.validProdPlanKeys.has(key)) {
          if (!t.inspectionDoneBy && !t.cb && !t.respPrsn) {
            dayToken.removeToken(i);
          }
        }
      }
    }
  }

  // TODO: When upgrading to Angular 8+, replace with async/await version:
  // Sync all changes (updates + deletions) to Production Plan - only loads months with changes
  private syncChangesToProductionPlan(onDone: () => void): void {
    if (!this.pendingOperations.length) { onDone(); return; }
    
    // Get unique source months from pending operations
    const uniqueMonths = this.getUniqueSourceMonths();
    if (!uniqueMonths.length) { onDone(); return; }
    
    this.processMonthSync(uniqueMonths, 0, onDone);
  }

  // Extract unique months from pending operations
  private getUniqueSourceMonths(): Date[] {
    const monthKeys = new Set<string>();
    const months: Date[] = [];
    
    for (const op of this.pendingOperations) {
      if (op.sourceMonth) {
        const key = `${op.sourceMonth.getFullYear()}-${op.sourceMonth.getMonth()}`;
        if (!monthKeys.has(key)) {
          monthKeys.add(key);
          months.push(op.sourceMonth);
        }
      }
    }
    return months;
  }

  // Process each month sequentially
  private processMonthSync(months: Date[], idx: number, onDone: () => void): void {
    if (idx >= months.length) { onDone(); return; }
    
    const currentMonth = months[idx];
    this._dataService.loadDailyProdHighlights(currentMonth).subscribe(dph => {
      if (!dph || !dph.dayTokens) { 
        this.processMonthSync(months, idx + 1, onDone); 
        return; 
      }

      const changed = this.applyOperationsToMonth(dph, currentMonth);
      
      if (changed) {
        this._dataService.saveDailyProdHighlight(dph, false).subscribe(
          () => this.processMonthSync(months, idx + 1, onDone),
          () => this.processMonthSync(months, idx + 1, onDone)
        );
      } else {
        this.processMonthSync(months, idx + 1, onDone);
      }
    }, () => this.processMonthSync(months, idx + 1, onDone));
  }

  // Apply pending operations that belong to this specific month
  private applyOperationsToMonth(dph: DailyProdHighlights, targetMonth: Date): boolean {
    let changed = false;
    
    for (const op of this.pendingOperations) {
      // Only process operations for this month
      if (!op.sourceMonth || !this.isSameMonth(op.sourceMonth, targetMonth)) continue;
      
      for (const day of dph.dayTokens) {
        for (let i = day.dateTokens.length - 1; i >= 0; i--) {
          const row = day.dateTokens[i];
          const pName = this._dataService.getProductName(row.productId) || row.productId;
          const cName = this._dataService.getCustomerName(row.customerId) || row.customerId;
          
          if (pName === op.productName && cName === op.customerName) {
            if (op.type === 'delete') {
              day.removeToken(i);
              changed = true;
            } else if (op.type === 'update') {
              const fatStr = GenService.getDateFormatStr(op.newDate, 'DD-MM-YYYY').split('-').reverse().join('-');
              row.fatDate = fatStr as any;
              row.quantity = op.quantity;
              changed = true;
            }
          }
        }
      }
    }
    return changed;
  }

  // Check if two dates are in the same month
  private isSameMonth(d1: Date, d2: Date): boolean {
    if (!d1 || !d2) return false;
    return d1.getFullYear() === d2.getFullYear() && d1.getMonth() === d2.getMonth();
  }

  public getSelYear(): number {
    return this.currMonthDtObj.getFullYear();
  }
  public getSelMonth(): number {
    return this.currMonthDtObj.getMonth() + 1;
  }
  public setView(_viewNo: number): void {
    this.selView = _viewNo;
  }

  formatMonth(_dateObj:Date):string{
    if(_dateObj){
      return GenService.getDateFormatStr(_dateObj , "MMM-YYYY");
    }
    return '-';
  }
  getProductName(_prodId:string):string{
    if(_prodId)
      return this._dataService.getProductName(_prodId);
    return '';
  }
  getCustomerName(_custId:string):string{
    if(_custId)
      return this._dataService.getCustomerName(_custId);
    return '';
  }
  getInspectionDoneBy(_inspId:string):string{
    if(_inspId)
      return this._dataService.getInspectionDoneBy(_inspId);
    return '';
  }
  getData(option){
     if(option) return option
     return ''
  }
  getResponsiblePrsn(_prsn:string):string{
    if(_prsn) return this._dataService.getResponsiblePrsn(_prsn); 
    return ''
  }
  getTypeReady(_id:string):string{
    if(_id) return this._dataService.getTypeReady(_id)
    return ''
  }
  parseDate(dateString: string): Date {
    if (dateString) {
        return new Date(dateString);
    } else {
        return null;
    }
  }

}
